import {Component, Input, OnInit} from '@angular/core';
import {GetDuplicateClaimsService} from "./get-duplicate-claims.service";
import {GetDuplicateClaimsDto} from "../../../../auto-generated-server-dtos/adjuster/claim/duplicate-detection/get-duplicate-claims-dto";
import {DuplicateClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/duplicate-detection/duplicate-claim-dto";
import {DuplicateE2ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/duplicate-detection/duplicate-e2-claim-dto";
import {NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";

@Component({
  selector: 'app-duplicate-claims',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    RouterLink
  ],
  templateUrl: './duplicate-claims.component.html',
  styleUrl: './duplicate-claims.component.scss'
})
export class DuplicateClaimsComponent implements OnInit {
  @Input() claimId!: number;
  claimsPortalDuplicateWarrantyClaims?: DuplicateClaimDto[] | null = null;
  claimsPortalDuplicateVehicleClaims?: DuplicateClaimDto[] | null = null;
  e2DuplicateWarrantyClaims?: DuplicateE2ClaimDto[] | null = null;
  e2DuplicateVehicleClaims?: DuplicateE2ClaimDto[] | null = null;

  constructor(private getDuplicateClaimsService: GetDuplicateClaimsService) {
  }

  ngOnInit(): void {
    this.getDuplicateClaimsService.getDuplicateClaims(this.claimId).subscribe((duplicateClaims: GetDuplicateClaimsDto) => {
      this.claimsPortalDuplicateWarrantyClaims = duplicateClaims.claimsPortalClaimDuplicatesOnWarrantyWithinTimeFrame;
      this.claimsPortalDuplicateVehicleClaims = duplicateClaims.claimsPortalClaimDuplicatesOnVehicleWithinTimeFrame;
      this.e2DuplicateWarrantyClaims = duplicateClaims.e2ClaimDuplicatesOnWarrantyWithinTimeFrame;
      this.e2DuplicateVehicleClaims = duplicateClaims.e2ClaimDuplicatesOnVehicleWithinTimeFrame;
    });
  }

}
